import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';

import CustomIcon from '../../utils/CustomIcon';

const styles = theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
  },
  icon: {
    fontSize: 'inherit',
    marginRight: theme.spacing(2),
  },
});

function Title({ classes, className, icon, children }) {
  return (
    <Typography variant="h1" className={clsx(classes.root, className)}>
      {icon && <CustomIcon className={classes.icon} icon={icon} />}
      {children}
    </Typography>
  );
}
Title.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  icon: PropTypes.string,
};

Title.defaultProps = {
  children: null,
  classes: {},
  className: null,
  icon: null,
};

export default withStyles(styles)(Title);
